export default {"src":"/_next/static/media/redit.fd717bb1.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};